import { Card, Grid, Skeleton, Typography } from "@mui/material";

import { moneyCommaSeparatorPoint } from "../../utils/helpers";
import { theme } from "../../utils/Theme";

const DashboardCard = (props) => {
  const { data, isLoading } = props;

  const dashboardDetails = [
    {
      name: "Advisors",
      value: data?.advisors || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Total Aum",
      value:
        moneyCommaSeparatorPoint(data?.aum) || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Companies",
      value: data?.companies || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Branch",
      value: data?.branches || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Employees",
      value: data?.employees || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Partners",
      value: data?.partners || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Clients",
      value: data?.clients || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Families",
      value: data?.families || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Portfolio",
      value: data?.portfolios || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Portfolio Groups",
      value: data?.portfolioGroups || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Transactions",
      value: data?.transactions || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Cash Entries",
      value: data?.cashEntries || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Transaction Uploads",
      value: data?.transactionUploads || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Contract Notes",
      value: data?.contractNotes || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Report Generated",
      value: data?.reports || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Leads",
      value: data?.leads || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Daily Active Users",
      value: data?.loginToday || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "New users today",
      value: data?.newUsersToday || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Equity Basket Mapped Portfolios",
      value:
        data?.modelPortfolioMappedPortfolios || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Equity Basket Orders",
      value: data?.modelPortfolioOrders || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Equity Basket UniqueStocks",
      value: data?.modelPortfolioUniqueStocks || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Equity Basket Versions",
      value: data?.modelPortfolioVersions || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Equity Basket",
      value: data?.modelPortfolios || (isLoading ? <Skeleton /> : 0),
    },
  ];

  return (
    <Grid container spacing={1}>
      {dashboardDetails.map((item) => (
        <Grid item spacing={2} xs={4} key={item.name}>
          <Card sx={{ p: 2 }}>
            <Typography fontSize={14} fontWeight={600}>
              {item.name}
            </Typography>
            <Typography
              fontSize={20}
              fontWeight={700}
              color={theme.palette.primary.main}
            >
              {item?.value}
            </Typography>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default DashboardCard;
